import {ApplicationRef, createComponent, EnvironmentInjector, Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {ContainerComponent} from '~shared/ng/components/dialog/container/container.component';
import {generateTagNameForComponent} from '~shared/utils/utils';

@Injectable()
export class ContainerService {
    public constructor(
        protected readonly appRef: ApplicationRef,
        protected readonly environmentInjector: EnvironmentInjector,
        @Inject(DOCUMENT)
        protected readonly document: Document,
    ) { }

    public provideEmptyContainer(): ContainerComponent {
        const componentElement = this.document.createElement(generateTagNameForComponent(ContainerComponent))

        const containerComponentRef = createComponent(ContainerComponent, {
            environmentInjector: this.environmentInjector,
            hostElement: componentElement
        })

        this.appRef.attachView(containerComponentRef.hostView);

        this.document.body
            .appendChild(
                componentElement
            );

        return containerComponentRef.instance;
    }
}
